import React, { ReactElement } from 'react';

import { classNames, noop } from '@philips-emr/tws-utils';

export interface ModalNavProps {
  className?: string;
  onClick?: () => void;
}

function ModalNav(props: ModalNavProps): ReactElement {
  const { className, onClick = noop } = props;

  const classes = classNames({
    'c-modal__nav': true,
    'u-hide@xsm': true,
    [`${className}`]: Boolean(className),
  });

  return <div className={classes} onClick={onClick} />;
}

export default ModalNav;
